// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/Iconfont/iconfont.css';
import axios from "axios";
import BaiduMap from 'vue-baidu-map';
import VCharts from 'v-charts';
import Aplayer from 'vue-aplayer';
import VueClipboard from 'vue-clipboard2';
import ECharts from 'vue-echarts/components/ECharts';

/*********************************************组件使用***********************************************/
//
//剪贴板组件
Vue.use(VueClipboard);

//音频播放组件
Aplayer.disableVersionBadge = true;
Vue.component("Aplayer", Aplayer);

//百度地图组件
Vue.use(BaiduMap, {
  ak: 'z9NzOPtvca64SmTiLu2vlmlhHfFCd5Z2'
});

//echarts的官方vue推荐组件
Vue.component("chart", ECharts);

//echarts的vue组件
Vue.use(VCharts);

//element组件
Vue.use(ElementUI);

/*********************************************全局方法***********************************************/
Vue.config.productionTip = false;

Vue.prototype.$ajax = axios;

Vue.prototype.$getJSON = function (url, params) {
  for (let param in params) {
    switch (typeof params[param]) {
      case 'object':
        params[param] = JSON.stringify(params[param]);
    }
  }
  return new Promise((resolve, rejects) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error);
      });
  })
};

//全局方法 播放录音文件 frequency和time用来当做标题显示
//播放使用第三方插件 以element 的 notification形式显示
Vue.prototype.$playAudio = function (radioFile, frequency, time) {
  const h = this.$createElement;
  let message = h('Aplayer', {
    attrs: {
      music: {
        src: radioFile,
        title: frequency,
        artist: time
      },
      autoplay: true,
      style: "width:290px;left:-12px;"
    }
  }, []);
  this.$notify.closeAll(); //关闭所有的notification实例
  this.$notify({
    title: "录音播放",
    message: message,
    duration: 0
  });
};

Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份 
    "d+": this.getDate(), //日 
    "h+": this.getHours(), //小时 
    "m+": this.getMinutes(), //分 
    "s+": this.getSeconds(), //秒 
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
    "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;

}

//判断数组中是否存在某元素
Array.prototype.in_array = function (element) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == element) {
      return true;
    }
  }
  return false;
}

//最小值
Array.prototype.min = function () {
  var min = this[0];
  var len = this.length;
  for (var i = 1; i < len; i++) {
    if (this[i] < min) {
      min = this[i];
    }
  }
  return min;
}
//最大值
Array.prototype.max = function () {
  var max = this[0];
  var len = this.length;
  for (var i = 1; i < len; i++) {
    if (this[i] > max) {
      max = this[i];
    }
  }
  return max;
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js